var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82816 10.4848L10.485 4.8279C11.6566 3.65633 13.5561 3.65633 14.7277 4.8279C15.8992 5.99947 15.8992 7.89897 14.7277 9.07054L8.01014 15.7881C7.42436 16.3738 6.47461 16.3738 5.88882 15.7881C5.30304 15.2023 5.30304 14.2525 5.88882 13.6667L11.8992 7.65633C12.0945 7.46106 12.0945 7.14448 11.8992 6.94922C11.704 6.75396 11.3874 6.75396 11.1921 6.94922L5.18172 12.9596C4.20541 13.9359 4.20541 15.5189 5.18172 16.4952C6.15803 17.4715 7.74094 17.4715 8.71725 16.4952L15.4348 9.77765C16.9969 8.21555 16.9969 5.68289 15.4348 4.12079C13.8727 2.55869 11.34 2.55869 9.77791 4.12079L4.12106 9.77765C3.92579 9.97291 3.92579 10.2895 4.12106 10.4848C4.31632 10.68 4.6329 10.68 4.82816 10.4848Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.0d7a5a587044a2606ca9ed2c7b709df6.svg";
export { ForwardRef as ReactComponent };